import React from 'react';
import {
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  makeStyles,
} from '@material-ui/core';
import SecurityIcon from '@material-ui/icons/Security';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const useStyles = makeStyles((theme) => ({
  title: { fontWeight: 700, textAlign: 'center', marginBottom: 4, color: '#1a3a5c' },
  subtitle: { textAlign: 'center', color: '#5a7a9a', marginBottom: theme.spacing(3) },
  iconBox: { textAlign: 'center', marginBottom: theme.spacing(2) },
  termCard: {
    border: '1px solid #e0e0e0',
    borderRadius: 8,
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(1.5),
    transition: 'all 0.2s',
  },
  termCardChecked: {
    border: '2px solid #4caf50',
    backgroundColor: '#f1f8e9',
  },
  cancelPolicy: {
    backgroundColor: '#f5f5f5',
    borderRadius: 8,
    padding: theme.spacing(2),
    marginTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'flex-start',
  },
}));

const TERMS = [
  {
    field: 'aptidao_fisica',
    label: 'Declaro estar apto(a) fisicamente para participar das atividades esportivas.',
    required: true,
  },
  {
    field: 'regras_organizacao',
    label: 'Estou ciente e concordo com as regras da organização.',
    required: true,
  },
  {
    field: 'uso_imagem',
    label: 'Autorizo o uso de imagem em materiais institucionais do Sindilegis.',
    required: false,
  },
  {
    field: 'lgpd',
    label:
      'Autorizo o Sindilegis a coletar, armazenar e tratar meus dados pessoais exclusivamente para fins do evento, conforme a Lei 13.709/2018.',
    required: true,
  },
];

export default function StepTermos({ formData, updateNestedFormData, activityConfig }) {
  const classes = useStyles();
  const t = formData.terms;

  return (
    <Box>
      <Box className={classes.iconBox}>
        <SecurityIcon style={{ fontSize: 48, color: '#1a3a5c' }} />
      </Box>
      <Typography variant="h5" className={classes.title}>
        Termos e Autorizações
      </Typography>
      <Typography variant="body2" className={classes.subtitle}>
        Leia e aceite os termos obrigatórios para finalizar sua inscrição
      </Typography>

      {TERMS.map((term) => {
        const checked = t[term.field];
        return (
          <Box
            key={term.field}
            className={`${classes.termCard} ${checked ? classes.termCardChecked : ''}`}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={checked}
                  onChange={() => updateNestedFormData('terms', term.field, !checked)}
                  color="primary"
                />
              }
              label={
                <Typography variant="body2">
                  {term.label}
                  {term.required && (
                    <span style={{ color: '#d32f2f' }}> *</span>
                  )}
                </Typography>
              }
            />
          </Box>
        );
      })}

      <Box className={classes.cancelPolicy}>
        <InfoOutlinedIcon style={{ marginRight: 12, color: '#1a3a5c', marginTop: 2 }} />
        <Box>
          <Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>
            Política de Cancelamento
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Em caso de desistência, comunicar o Sindilegis com 30 dias de antecedência.
            {activityConfig?.cancellationPhone ? (
              <>
                <br />
                Telefone: {activityConfig.cancellationPhone}
              </>
            ) : null}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
